import React, { useEffect, useState } from "react";
import SyledCheckboxMedication from "./SyledCheckboxMedication";
import Axios from "../../../services/Axios";
import APIVariables from "../../../services/api-variables";
import { registrationCategory } from "../../../constants/register.constants";

const TermsAndConditionsPrescriber = ({
  getBrochure,
  products,
  selectedProducts,
  productConfirmations,
  handleCheckboxes,
  checkboxesMedications,
  uniqueTitlesJoin,
  userType, // registrationCategory.PHARMACY or registrationCategory.PRESCRIBER
  institutionName,
}) => {
  const [registrationTexts, setRegistrationTexts] = useState({
    form_header: "",
    molecule_header: "Prescriber {title} Confirmation",
    form_footer: "",
    raw: {},
  });

  useEffect(() => {
    // fetch configurable texts from admin endpoint
    const fetchRegistrationTexts = async () => {
      try {
        const resp = await Axios.post(
          APIVariables?.USER_REGISTRATION || "/settings/user-registration/",
          { user_type: userType === registrationCategory.PHARMACY ? 1 : 0 }
        );
        const data = resp?.data || {};
        // keep raw object so we can access dynamic keys (<product>_responsability, etc.)
        setRegistrationTexts({
          form_header: data.first_confirmation || "",
          molecule_header:  "Prescriber {title} Confirmation",
          form_footer: data.second_confirmation || "",
          raw: data,
        });
      } catch (err) {
        // leave defaults if fetch fails
        // console.error("Failed to load registration texts", err);
      }
    };

    fetchRegistrationTexts();
  }, [userType]);

  // helper: interpolate placeholders in API-provided templates
  const interpolate = (tpl = "", title = "") => {
    if (!tpl) return "";
    return tpl
      .replace(/\{\{\s*PRODUCTS_LIST\s*\}\}/gi, uniqueTitlesJoin || title || "")
      .replace(/\{\{\s*INSTITUTION_NAME\s*\}\}/gi, institutionName || "");
  };

  function compareArrayWithObjects(array, objects) {
    const matchingParameters = [];

    for (let i = 0; i < array.length; i++) {
      const currentNumber = array[i];

      for (let j = 0; j < objects.length; j++) {
        const currentObject = objects[j];

        if (currentNumber === currentObject.product_id) {
          matchingParameters.push(currentObject.name);
        }
      }
    }

    // Return the array of matching parameters
    return matchingParameters;
  }

  // Usage
  const result = compareArrayWithObjects(selectedProducts, products);

  const keysandvalues = productConfirmations?.reduce(
    (acc, innerArray, index) => {
      return acc.concat(
        innerArray?.map((element) => {
          return {
            title: result[index],
            id: `${index}-${element.confirmation_id}`,
            val: element.confirmation_name,
            brochure_name: element.brochure_name,
            brochure_id: element.brochure_id,
          };
        })
      );
    },
    []
  );

  const uniqueTitles = [
    ...new Set(keysandvalues.map((element) => element.title)),
  ];

  const handleGetBrochure = (event, brochureId) => {
    event.stopPropagation();
    event.preventDefault();

    getBrochure(brochureId);
  };

  // helper to render molecule header with title interpolation
  const renderMoleculeHeader = (tpl, t) => {
    if (!tpl) return `Prescriber ${t} Confirmation`;
    return tpl.replace(/\{?\{?title\}?\}?/gi, t);
  };

  return (
    <React.Fragment>
      {/* configurable form header (if provided) */}
      {registrationTexts.form_header ? (
        <div
          className="form-header"
        >{interpolate(registrationTexts.form_header)}</div>
      ) : null}

      <div className="prescriber-confirmation">
        <div>
          <SyledCheckboxMedication>
            {uniqueTitles.map((title) => (
              <div key={title}>
               <h3 className="title-details orient">
                  {renderMoleculeHeader(registrationTexts.molecule_header, title)}
                </h3>

                {/* use product-specific responsibility text when available, otherwise fallback */}
                {(() => {
                  // prefer product-level configured text (pharmacist or prescriber) when available
                  const productObj = products?.find((p) => p?.name === title);
                  const productLevelText =
                    userType === registrationCategory.PHARMACY
                      ? productObj?.pharmacist_confirmation_text
                      : productObj?.prescriber_confirmation_text;

                  // If viewing as pharmacist: show only pharmacist_confirmation_text; if it's null show nothing.
                  if (!productLevelText) return null;
            
                  return <p>{interpolate(productLevelText, title)}</p>;
                  

                })()}

                {keysandvalues
                  .filter((element) => element.title === title)
                  ?.map((element, index) => (
                    <div
                      onClick={() => handleCheckboxes(element.id)}
                      className="custom-checkbox checkboxes-block"
                      key={index}
                    >
                      <input
                        type="checkbox"
                        checked={checkboxesMedications.includes(element.id)}
                        readOnly
                      />
                      <span className="checkmark margin" />
                      <p className="text-for-checkboxes">
                        {index + 1}.{" "}
                        {element.val?.split("\r\n")?.map((line, lineIndex) => (
                          <React.Fragment key={lineIndex}>
                            {line.includes("<brochure>") ? (
                              <>
                                {line
                                  .split("<brochure>")
                                  .map((textPart, partIndex) => (
                                    <React.Fragment key={partIndex}>
                                      {partIndex > 0 && (
                                        <span
                                          className="brochure-link"
                                          onClick={(e) =>
                                            handleGetBrochure(e, element)
                                          }
                                        >
                                          {element.brochure_name}
                                        </span>
                                      )}
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: textPart,
                                        }}
                                      />
                                    </React.Fragment>
                                  ))}
                              </>
                            ) : (
                              <span
                                dangerouslySetInnerHTML={{ __html: line }}
                              />
                            )}
                            {lineIndex !==
                              element?.val?.split("\r\n").length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                    </div>
                  ))}
              </div>
            ))}
          </SyledCheckboxMedication>
        </div>
      </div>
      {/* configurable form footer (supports placeholder {products} to inject product list) */}
      <div className="confirm">
        <span>{interpolate(registrationTexts?.form_footer)}</span>
      </div>
    </React.Fragment>
  );
};
export default TermsAndConditionsPrescriber;
